// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-4e161461],.fade-leave-active[data-v-4e161461]{transition:opacity .3s}.fade-enter-from[data-v-4e161461],.fade-leave-to[data-v-4e161461]{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
